import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppShell from "@/components/layout/AppShell";
import Sharing from "@/pages/Sharing";
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import XLSyncLogo from "@/components/brand/XLSyncLogo";

function AuthLoading() {
  return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 rounded-full border-2 border-[var(--xl-primary)] border-t-transparent animate-spin" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

function PublicSharingLayout() {
  return (
    <div className="min-h-screen bg-[var(--xl-bg)]">
      <header className="border-b border-[var(--xl-line)] bg-[var(--xl-surf)]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 min-h-[5.5rem] py-2 flex items-center justify-between gap-4">
          <XLSyncLogo size="lg" />
          <Button size="sm" asChild className="gap-1.5 flex-shrink-0">
            <Link to="/login">
              <LogIn className="w-4 h-4" /> Sign in
            </Link>
          </Button>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <Sharing />
      </main>

      <p className="text-center text-[11px] text-muted-foreground pb-6">
        Shared securely via XLSync
      </p>
    </div>
  );
}

/** Public when logged out; normal app shell with sidebar when logged in. */
export default function SharingRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <AuthLoading />;

  if (isAuthenticated) {
    return (
      <AppShell>
        <Sharing />
      </AppShell>
    );
  }

  return <PublicSharingLayout />;
}
